// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"23b55e4c","621":"64aacda6"}[chunkId] + ".chunk.css";
};